import styled from 'styled-components';
import { Rect } from 'dragonmouse-shared/geometry';
import { unthemed } from 'tokens';

interface BaseProps {
	sceneBounds: Rect;
	backgroundColor?: string;
}
export const Base = styled.div<BaseProps>`
	position: absolute;
	top: ${(p) => p.sceneBounds.y}px;
	left: ${(p) => p.sceneBounds.x}px;
	width: ${(p) => p.sceneBounds.width}px;
	height: ${(p) => p.sceneBounds.height}px;
	background: ${(p) => p.backgroundColor ?? unthemed.gray[900]};

	img,
	iframe {
		border: none;
		position: absolute;
		top: 0;
		left: 0;
	}
`;

export const Overlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	background-color: ${unthemed.gray[900]}bb;
`;

export const StatusIndicator = styled.div`
	display: flex;
	justify-content: center;
	align-items: end;
	height: 38%;
	padding-bottom: 7%;
`;

export const OverlayText = styled.div<{ aboveFullZoom: boolean }>`
	// layout
	display: flex;
	justify-content: center;
	align-items: center;
	// coordinates are in scene coordinate space so 60px usually not that big
	width: calc(100% - 60px);
	padding-left: 30px;
	padding-right: 30px;

	// style
	font-family: 'JetBrains Mono', sans-serif;
	font-size: ${(p) => (p.aboveFullZoom ? '20px' : '32px')};
	font-weight: 600;
	color: ${unthemed.gray[100]};
	text-align: center;
	line-height: 1.7;
	word-break: break-word;
	overflow-wrap: break-word;
`;

export const FrameViewLoader = styled.div`
	margin-top: -4px;
	padding-right: 24px;
	flex-shrink: 0;
`;
